import { createFileRoute } from "@tanstack/react-router";

import Results from "~/pages/UsdaAuditFeedback/Results";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/usda-audit-feedback/")({
  staticData: ROUTE_STATIC.usdaAuditFeedback,
  component: Results,
});
